<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="thehistoryof48">
<p class="para2"><em class="italic">Motto</em>: “Advantage, Honor and Glory” (<em class="italic">Polza, chest i slava</em>)</p>
<p class="para"><em class="italic">Color of Ribbon:</em> Red with Black edges</p>
<p class="centerImage"><img alt="image" id="imgfr32" src="images/imgfr32.jpg"/></p>
<p class="caption1"><em class="italic">Order of St. Vladimir 4th Class</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// therussian_thehistoryof48.vue?b4f6058e